// extracted by mini-css-extract-plugin
export default {"user-avatar":"_1R7CO","userAvatar":"_1R7CO","pixelated":"_185sl"};